import { render, staticRenderFns } from "./figure.vue?vue&type=template&id=712902a4&scoped=true&lang=pug&"
var script = {}
import style0 from "./figure.vue?vue&type=style&index=0&id=712902a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712902a4",
  null
  
)

export default component.exports